import clsx from 'clsx';

import './styles/StepIcon.scss';
import { StepIconProps } from '@mui/material';

interface Props extends StepIconProps {}

export default function StepIcon(props: Props) {
  return (
    <div
      className={clsx('step-icon', {
        'step-icon--active': props.active,
        'step-icon--completed': props.completed
      })}
    >
      {props.icon}
    </div>
  );
}
